import React, { useState, useEffect } from 'react';
import { Col, Row } from 'antd';
import 'src/pages/userComponents/menus/Congratulation page/congratulation.scss';
import CheckBox from 'src/assets/img/SalesForce_Icon/CheckBox.svg';
import Activeline from 'src/assets/img/SalesForce_Icon/ActiveLine.svg';
import Warning from 'src/assets/img/SalesForce_Icon/Warning.svg';
import inActiveline from 'src/assets/img/SalesForce_Icon/inActiveLine.svg';
import TextComponent from '@sharedComponent/typography/TextComponent';

const TimelineComponent = ({ companyInfoCangratulationData }) => {
	const [timeLineData, setTimeLineData] = useState([
		{ status: 'active', titleMessage: 'Sign Up Completed!', description: null },
		{ status: 'warning', titleMessage: 'Sign the Edenred Agreement', description: 'Ask your Authorised signatory to sign the agreement.' },
	]);
	useEffect(() => {
		if (companyInfoCangratulationData && companyInfoCangratulationData.agreementSigned) {
			let nTimeLineData = timeLineData;
			nTimeLineData[1].status = 'active';
			setTimeLineData(nTimeLineData)
		}
	}, [companyInfoCangratulationData])

	const getCheckListCount = () => {
		return `Check list (${companyInfoCangratulationData && companyInfoCangratulationData.agreementSigned ? 2 : 1} /2)`;
	}
	return (
		<>
			<div className="check_list_title_container">
				<TextComponent className="checklist-title-text">{getCheckListCount()}</TextComponent>
			</div>
			<Row className="timeLineMainWrapper">
				{timeLineData.map((res, index) => {
					return (
						<div key={index} className="timeLineContainer">
							<Col className="iconContainer">
								<img
									src={((companyInfoCangratulationData && companyInfoCangratulationData.agreementSigned) || res.status == 'active') ? CheckBox : Warning}
									alt="Girl in a jacket"
									style={{ width: '30px' }}></img>
								{timeLineData.length - 1 === index ? null : (
									<img
										src={
											companyInfoCangratulationData && companyInfoCangratulationData.agreementSigned ? Activeline : inActiveline
										}
										style={{ width: '30px', height: '50px' }}></img>
								)}
							</Col>
							<Col className="descriptionContainer">
								<div style={{ marginTop: res.description && timeLineData.length == index + 1 ? '-10px' : 'none' }}>
									{res.status == 'warning' ? (
										<TextComponent className="">{res.titleMessage}</TextComponent>
									) : (
										<TextComponent className={res.status == 'active' ? 'timeline-done-text' : 'timeline-pending-text'}>
											<span>{res.titleMessage}</span>
										</TextComponent>
									)}
								</div>
								<div style={{ marginTop: '3px' }}>
									<TextComponent className="timeline-description-text">{res.description}</TextComponent>
								</div>
							</Col>
						</div>
					);
				})}
			</Row>
		</>
	);
};

export default TimelineComponent;
